<script lang="ts">
  import { slide } from "svelte/transition"
  import Modal from "$app/components/Modal.svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  let { open = $bindable(), showTermsModal } = $props()
  let saving = $state(false)
  let has_accepted_community_terms = $state(
    appStore.current_user.has_accepted_community_terms
  )

  async function saveUserTerms(): Promise<void> {
    saving = true
    try {
      const resp = await xhr.put(`/users/${appStore.current_user.id}.json`, {
        user: { has_accepted_community_terms: has_accepted_community_terms }
      })
      saving = false
      toast("Settings saved", "success")
      appStore.current_user.has_accepted_community_terms =
        has_accepted_community_terms
    } catch (e: any) {
      Honeybadger.notify(e)
    } finally {
      saving = false
    }
  }
</script>

<Modal bind:open>
  <div class="px-6 py-4 text-sm leading-6 bg-white" transition:slide>
    <p class="py-4 text-base text-gray-600">
      {#if appStore.plan.community_read_only}
        Your Plan admin has set the Community to <span class="font-bold"
          >read-only mode</span
        >. You will be able to view all Community content but will not be able
        to create new posts or comment on posts. Contact your Plan Admin if you
        have any questions.
      {:else}
        Your Plan admin has enabled full Community access, however in order to
        create new posts or comment on posts please ensure you have access the
        Community Terms of Use.
      {/if}
    </p>
    {#if !appStore.plan.community_read_only}
      <div class="flex justify-center items-center gap-x-4 py-3">
        <button
          onclick={() => {
            open = false
            showTermsModal()
          }}
          class="mt-0 pt-0 text-base font-medium hover:cursor-point underline hover:text-blue-600"
        >
          Community Terms Acceptance
        </button>
        <select
          class="border w-64 border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-blue-500 sm:text-sm"
          bind:value={has_accepted_community_terms}
        >
          <option value={false}>Not Accepted</option>
          <option value={true}>Accepted</option>
        </select>

        <button
          onclick={saveUserTerms}
          disabled={saving}
          class="rounded bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500"
        >
          Save Settings
        </button>
      </div>
    {/if}
  </div>
</Modal>
